import { Routes as RouteList } from '@models/routes';
import { flattenRoutes } from '@utils/routes';
import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { ErrorRouter } from './ErrorPage';
import { LegalRouter } from './Legal';
import { notFoundRoutes } from './NotFound';
import { QuestionnaireRoutes } from './Questionnaire';
import { ThankRoutes } from './Thankyou';

const routes: RouteList = flattenRoutes([...QuestionnaireRoutes, ...ThankRoutes, ...ErrorRouter, ...LegalRouter, ...notFoundRoutes]);

export const NoAnalyticsRouter = () => {
  return (
    <BrowserRouter>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Routes>
          {routes.map(({ path, component: Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <Suspense fallback={null}>
                  <Component />
                </Suspense>
              }
            />
          ))}
        </Routes>
      </QueryParamProvider>
    </BrowserRouter>
  );
};
